import { Navigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import { getloggedInUserRoles } from "./Tracks/DeliveryLeadership/app/DeliveryLeadershipSlice";
import LoadingSpinner from "./utils/loadingSpinner";

const PrivateRoute = ({ trackId, allowedRoles, children }) => {
  const dispatch = useDispatch();

  const { enterpriseID, loggedInUserRoles, rolesLoading } = useSelector(
    (state) => state.deliveryLeadership
  );

  // useEffect(() => {
  //   if (enterpriseID) {
  //     dispatch(
  //       getloggedInUserRoles({
  //         loggedInUser: enterpriseID,
  //         trackId,
  //       })
  //     );
  //   }
  // }, [enterpriseID, trackId, dispatch]);

  if (rolesLoading) {
    return <LoadingSpinner text="Checking access..." />;
  }

  const hasAccess = allowedRoles.some(role =>
    loggedInUserRoles.includes(role)
  );

  return hasAccess ? children : <Navigate to="/access-denied" replace />;
};

export default PrivateRoute;
